<template>
    <div class="ma-0" style="position:relative;width:100%;height:100%;">
        <div class="ma-0 pa-0 d-flex flex-column" style="position:relative;width:100%;height:100%;">
            <div class="flex-grow-1 flex-shrink-1" style="position:relative;">
                <div style="position:absolute;top:0px;left:0px;right:0px;bottom:0px;">
                    <v-data-table :headers="headers"  fixed-header :items="records" class="elevation-1 result-table mt-0"
                        width="100%" height="100%" single-select show-select :item-key="itemKey"
                        v-model="selected"
                        calculate-widths
                        :server-items-length="tableOptions.total"
                        :page.sync="tableOptions.pageNo"
                        :items-per-page.sync="tableOptions.pageSize"
                        :hide-default-footer='true'
                        :disable-pagination='true'
                    >
                    
                    </v-data-table>
                </div>
            </div>

            <div class="flex-grow-0 flex-shrink-0 py-0 my-0" v-show="!hidePageTool">
                <Pagination :items="getPageSizes()"
                    :total="tableOptions.total"
                    :pageNo="tableOptions.pageNo"
                    :pageSize="tableOptions.pageSize"
                    @update:pageNo="handlePageNoChanged"
                    @update:pageSize="handlePageSizeChanged"
                >
                </Pagination>
            </div>
        </div>
    </div>
</template>

<script>

    import Pagination from '@/components/common/pagination/Pagination.vue';

    export default {
        name:'DefaultQueryResultPane',
        props:['context','pageSizes'], 
        components:{
            'Pagination':Pagination,
        },
        data () {
            return {
                name:'DefaultQueryResultPane',
                defaultHeaders: [
                    {text: '编号',value: 'id',sortable: false,width: 150,divider: true},
                ],
                
                condition:{
                    
                },
                tableOptions:{
                    pageNo:1,
                    pageSize:10,
                    total:0
                },
                records:[],
                selected:[],
                worker:{},
                defaultPageSizes:[10,20,50,100]
            }
        },
        methods:{
            initComponent(){

                this.worker = this.getQueryResultWorker();
            },
            initSignals(){
                if(!this.signalInited){
                    let me = this;

                    this.getSignals().loadQueryResultAsked.add(function(condition){
                        me.condition = condition;
                        me.doQuery();
                    });

                    this.getSignals().exportQueryResultAsked.add(function(){
                        me.doExport();
                    });
                }
            },
            getModeHelper(){
                return this.context.modeHelper;
            },
            getMessageDialogHelper(){
                return  this.context.messageDialogHelper;
            },
            getSignals(){
                return this.context.signals;
            },
            getQueryResultWorker(){
                return this.context.queryResultWorker;
            },
            
            getFirstSelectedRecord(){
                if((this.selected)&&(this.selected.length>0))
                    return this.selected[0];
                return null;    
            },
            getSelectedRecord(){
                return this.selected;   
            },
            getRecordTotal(){
                if (this.tableOptions && this.tableOptions.total)
                    return this.tableOptions.total;
                return 0;
            },
            getPageSizes(){
                if(this.pageSizes && this.pageSizes.length && this.pageSizes.length>0)
                    return this.pageSizes;
                return this.defaultPageSizes;

            },
            async load(params){
                let me = this;
                if((!this.worker) && (!this.worker.loadData)){
                    throw new Error("worker not found loadData function");
                    return;
                }
                
                this.clearSelected();
                
                await this.worker.loadData(params,function(data){
                    me.records = data.records;
                    me.tableOptions.total = data.total;
                });
                
            },
            async doQuery(){                
                let me = this;
                console.log("default queryResultPane begin query");
                console.log(this.condition);
                let params = {};
                
                if(this.paged){
                    params = {
                        pageNo:me.tableOptions.pageNo,
                        pageSize:me.tableOptions.pageSize,
                    };
                }
                Object.assign(params,me.condition);
                try{
                    
                    await me.load(params);
                }catch(err){
                    me.getMessageDialogHelper().errMsg('错误','查询失败:'+err.message);
                }
            },
            doExport(){
                console.log("default queryResultPane export signal received");
            },
            clearSelected(){
                this.selected=[];
            },

            handlePageNoChanged(pageNo) {
                this.tableOptions.pageNo = pageNo;
                this.doQuery();
            },

            handlePageSizeChanged(pageSize) {
//                this.tableOptions.pageNo = 1
                this.tableOptions.pageSize = pageSize
                //不自动执行，可能会跳过参数检查
                //this.doQuery()
            },
        },
        computed:{
            headers(){
                if(this.worker && this.worker.headers)
                    return this.worker.headers;
                return this.defaultHeaders;    
            },
            itemKey(){
                return  this.bill.getQueryResultKeyName();
            },
            paged(){
                if(this.worker && this.worker.paged)
                    return true;
                return false;    
            },
            hidePageTool(){
                return !this.paged;   
            }
        },
        created(){
            this.bill = this.context.bill;
            this.signals = this.context.signals;
            this.initComponent();
            this.initSignals();
        },
        mounted(){
            console.log("defaultQueryResultPane loaded");
        }
    }
</script>

<style scoped>
    .queryResultPaneRoot{
        position:absolute;
        left:0px;
        top:0px;
        bottom: 0px;
        right:0px;
        overflow-y: scroll;
    }

    .result-table{
        width:100%;
        height:100%;
    }

</style>
